import { CommunityProfilesService } from 'src/app/core/services/community-profiles.service';
import { knownPeople, PanelMember, publicMembers } from '../community-format';

export interface MemberSelf {
  userId: string;
  nickname: string;
  profileUrl?: string;
}

/**
 * Members of one space for the right panel, cached between change-detection runs.
 * Private: the inherited private member list. Public: PubNub channel members, named
 * from people seen in the space, the current user, then getPublicProfiles (once per id).
 */
export class ChatMembers {
  private version = 0;
  private cache: { source: any; count: number; version: number; list: PanelMember[] } | null = null;

  constructor(private readonly profiles: CommunityProfilesService) {}

  list(isPrivate: boolean, privateList: any[], pubnubMembers: any, messages: any[], self: MemberSelf | null): PanelMember[] {
    const source = isPrivate ? privateList : pubnubMembers;
    const count = messages.length;
    if (this.cache?.source !== source || this.cache.count !== count || this.cache.version !== this.version) {
      const people = knownPeople(messages);
      if (self) people.set(self.userId, { nickname: self.nickname, profileUrl: self.profileUrl });
      const list = isPrivate ? source || [] : publicMembers(source, id => people.get(id) ?? this.profiles.get(id));
      this.cache = { source, count, version: this.version, list };
      if (!isPrivate) this.loadMissingNames(list);
    }
    return this.cache.list;
  }

  private loadMissingNames(list: PanelMember[]): void {
    const unnamed = list.filter(m => !m.nickname).map(m => m.userId);
    this.profiles.load(unnamed).then(added => {
      if (added) this.version++;
    });
  }
}
